import { ListHelper } from '~/training/sequence/templates/translators/itemHelpers/ListHelper';
import {
  BULLET_LIST,
  CARD,
  CardDefinition,
  LayoutColumnsDefinition,
  LayoutListDefinition,
  LAYOUT_COLUMNS,
  LAYOUT_LIST,
  TEXT
} from '../items';
import { Translator } from '../Translator';
import { PhoneHelper } from './itemHelpers/PhoneHelper';
import { ItemOfType } from './itemHelpers/types';
import { translate } from './translate';
import {
  KICKER_HINT,
  OPTIONAL_TEXT_FIELDS,
  optionalFieldsInEditor,
  optionalFieldValues
} from '../utils/optionalFields';
import { templateTextFieldsEnabled } from '../utils/templateTextFields';
import { useEditorStore } from '~/shell/Store';

export const SocialMedia13: Translator = sequence => {
  const optional = optionalFieldsInEditor(OPTIONAL_TEXT_FIELDS);
  const { editorMode } = useEditorStore.getState();
  const columns = {
    type: LAYOUT_COLUMNS,
    id: `${sequence.id}-columns`,
    items: [],
    values: {}
  } as LayoutColumnsDefinition;

  let isPhone = false;

  (sequence.items ?? []).forEach(item => {
    if (item.__typename === 'Phone') {
      isPhone = true;
    }
  });
  const root = translate(sequence, item => {
    switch (item.__typename) {
      case 'Phone':
        columns.items.push(
          PhoneHelper(
            item as ItemOfType<'Phone'>,
            sequence,
            sequence.personalization
          )
        );
        break;

      case 'List':
        columns.items.push({
          id: item.id,
          type: LAYOUT_LIST,
          values: {
            align: { _: 'center', lg: 'left' },
            height: { _: 'auto', lg: '100%' },
            padded: true
          },
          items: [
            {
              type: CARD,
              id: '1',
              values: {
                clearStyles: 'md',
                height: 'auto',
                width: 'auto'
              },
              items: [
                {
                  id: item.id,
                  type: LAYOUT_LIST,
                  values: { align: 'left', height: 'auto' },
                  items: [
                    // Beside a phone, learners see the kicker when it has
                    // text; before the template text fields the editor left
                    // it out there.
                    ...(!isPhone ||
                    optional.includes('subtitle') ||
                    (item.subtitle &&
                      (!editorMode || templateTextFieldsEnabled()))
                      ? [
                          {
                            type: TEXT,
                            id: item.id + '_subtitle',
                            items: [],
                            values: {
                              ...optionalFieldValues(
                                optional,
                                'subtitle',
                                KICKER_HINT
                              ),
                              value: item.subtitle,
                              variant: 'sub_heading',
                              icon: item.icon
                            }
                          }
                        ]
                      : []),
                    {
                      type: TEXT,
                      id: item.id + '_title',
                      items: [],
                      values: {
                        ...optionalFieldValues(optional, 'title'),
                        value: item.title,
                        variant: 'heading1'
                      }
                    },
                    {
                      type: BULLET_LIST,
                      id: item.id,
                      values: [],
                      items: ListHelper({ items: item.items, showTimer: false })
                    }
                  ]
                }
              ]
            } as CardDefinition
          ]
        } as LayoutListDefinition);
    }
    return null;
  });

  root.items.push(columns);
  return root;
};
